import $ from "jquery";

export const EditProfile = function () {
	// Check if we're on edit-profile page
	if (!($("#edit-profile").length > 0)) return false;

	// Import and use the same functionality as SetupProfile
	// We'll reuse the same logic but with edit-specific configurations
	const $elms = {
		page: $("#edit-profile"),
		form: $("#edit-profile-form"),
		uploadPhoto: $(".js-upload-photo"),
		removePhoto: $(".js-remove-photo"),
		saveProfile: $(".js-save-profile"),
		photo: $("#edit-profile-photo"),
		cameraInput: $(
			'<input type="file" accept="image/*" capture="environment" style="display: none;">',
		),
		galleryInput: $(
			'<input type="file" accept="image/*" style="display: none;">',
		),
		firstName: $("#fname"),
		lastName: $("#lname"),
		defaultNote: $("#default-note"),
		generatedNote: $("#generated-note"),
		generatedUsername: $("#generated-username"),
	};

	// Get the default photo URL from the current img src
	const defaultPhotoUrl = $elms.photo.attr("src");
	let selectedPhotoFile = null; // Store the selected file
	let hasExistingPhoto =
		defaultPhotoUrl && !defaultPhotoUrl.includes("user-default.png");

	// Append hidden file inputs to form
	$elms.form.append($elms.cameraInput);
	$elms.form.append($elms.galleryInput);

	const validateImageFile = (file) => {
		const validTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
		const maxSize = 5 * 1024 * 1024; // 5MB

		if (!validTypes.includes(file.type)) {
			alert("Please select a valid image file (JPEG, PNG, GIF, or WebP)");
			return false;
		}

		if (file.size > maxSize) {
			alert("Image file size must be less than 5MB");
			return false;
		}

		return true;
	};

	const sanitizeInput = (input) => {
		// Remove any non-alphanumeric characters except spaces
		return input.replace(/[^a-zA-Z0-9\s]/g, "");
	};

	const sanitizeUsername = (input) => {
		// Remove all non-alphanumeric characters including spaces
		return input.replace(/[^a-zA-Z0-9]/g, "");
	};

	const generateUsername = () => {
		const firstName = $elms.firstName.val().toLowerCase().trim();
		const lastName = $elms.lastName.val().toLowerCase().trim();

		if (firstName && lastName) {
			// Remove spaces for username generation
			const cleanFirstName = sanitizeUsername(firstName);
			const cleanLastName = sanitizeUsername(lastName);
			const username = `${cleanFirstName}${cleanLastName}`;
			$elms.generatedUsername.text(username);
			$elms.defaultNote.hide();
			$elms.generatedNote.show();
		} else {
			$elms.generatedUsername.text("");
			$elms.defaultNote.show();
			$elms.generatedNote.hide();
		}
	};

	const validateForm = () => {
		// For edit profile, photo is optional (can keep existing)
		const hasValidPhoto = selectedPhotoFile || hasExistingPhoto;
		const isValid =
			$elms.firstName.val() && $elms.lastName.val() && hasValidPhoto;
		$elms.saveProfile.prop("disabled", !isValid);
		return isValid;
	};

	// Create custom photo source modal
	const createPhotoSourceModal = () => {
		const modal = $(`
			<div class="photo-source-modal" style="
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				z-index: 10000;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				box-sizing: border-box;
			">
				<div class="photo-source-modal__content" style="
					background: white;
					border-radius: 12px;
					padding: 24px;
					max-width: 320px;
					width: 100%;
					text-align: center;
					box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
				">
					<h3 style="
						margin: 0 0 16px 0;
						font-size: 18px;
						font-weight: 600;
						color: #333;
					">${window.CFG.strings.photoSourceTitle}</h3>
					<p style="
						margin: 0 0 24px 0;
						color: #666;
						font-size: 14px;
					">${window.CFG.strings.photoSourceDescription}</p>
					<div style="
						display: flex;
						flex-direction: column;
						gap: 12px;
					">
						<button class="photo-source-btn photo-source-btn--camera" style="
							background: #007cba;
							color: white;
							border: none;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							📷 ${window.CFG.strings.takePhotoText}
						</button>
						<button class="photo-source-btn photo-source-btn--gallery" style="
							background: #f0f0f0;
							color: #333;
							border: none;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							🖼️ ${window.CFG.strings.chooseFromGalleryText}
						</button>
						<button class="photo-source-btn photo-source-btn--cancel" style="
							background: transparent;
							color: #666;
							border: 1px solid #ddd;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							${window.CFG.strings.cancelText}
						</button>
					</div>
				</div>
			</div>
		`);

		// Add hover effects
		modal.find(".photo-source-btn").hover(
			function () {
				if ($(this).hasClass("photo-source-btn--camera")) {
					$(this).css("background-color", "#005a87");
				} else if ($(this).hasClass("photo-source-btn--gallery")) {
					$(this).css("background-color", "#e0e0e0");
				} else if ($(this).hasClass("photo-source-btn--cancel")) {
					$(this).css("background-color", "#f8f8f8");
				}
			},
			function () {
				if ($(this).hasClass("photo-source-btn--camera")) {
					$(this).css("background-color", "#007cba");
				} else if ($(this).hasClass("photo-source-btn--gallery")) {
					$(this).css("background-color", "#f0f0f0");
				} else if ($(this).hasClass("photo-source-btn--cancel")) {
					$(this).css("background-color", "transparent");
				}
			},
		);

		return modal;
	};

	// Initial validation and username generation
	validateForm();
	generateUsername();

	// Initialize username display with current values
	const currentFirstName = $elms.firstName.val();
	const currentLastName = $elms.lastName.val();
	if (currentFirstName && currentLastName) {
		generateUsername();
	}

	// Add input event listeners for real-time validation and username generation
	$elms.firstName.on("input", function () {
		const sanitized = sanitizeInput($(this).val());
		$(this).val(sanitized);
		validateForm();
		generateUsername();
	});

	$elms.lastName.on("input", function () {
		const sanitized = sanitizeInput($(this).val());
		$(this).val(sanitized);
		validateForm();
		generateUsername();
	});

	$elms.uploadPhoto.on("click", function () {
		// Check if we're on a mobile device
		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			);

		if (isMobile) {
			// Show custom modal for mobile
			const modal = createPhotoSourceModal();
			$("body").append(modal);

			// Handle button clicks
			modal.find(".photo-source-btn--camera").on("click", function () {
				modal.remove();
				$elms.cameraInput.trigger("click");
			});

			modal.find(".photo-source-btn--gallery").on("click", function () {
				modal.remove();
				$elms.galleryInput.trigger("click");
			});

			modal.find(".photo-source-btn--cancel").on("click", function () {
				modal.remove();
			});

			// Close modal when clicking outside
			modal.on("click", function (e) {
				if (e.target === modal[0]) {
					modal.remove();
				}
			});
		} else {
			// Desktop - use gallery input
			$elms.galleryInput.trigger("click");
		}
	});

	const handleFileChange = function (e) {
		const file = e.target.files[0];
		if (file && validateImageFile(file)) {
			selectedPhotoFile = file; // Store the valid file
			const reader = new FileReader();
			reader.onload = function (e) {
				$elms.photo.attr("src", e.target.result);
				$elms.photo.closest(".setup__photo").addClass("is-image-uploaded");
				validateForm(); // Revalidate after photo upload
			};
			reader.readAsDataURL(file);
		} else {
			selectedPhotoFile = null; // Clear stored file if invalid
			$elms.cameraInput.val(""); // Clear the invalid file
			$elms.galleryInput.val(""); // Clear the invalid file
			validateForm(); // Revalidate after failed upload
		}
	};

	$elms.cameraInput.on("change", handleFileChange);
	$elms.galleryInput.on("change", handleFileChange);

	$elms.removePhoto.on("click", function () {
		selectedPhotoFile = null; // Clear stored file
		$elms.photo.attr("src", defaultPhotoUrl);
		$elms.photo.closest(".setup__photo").removeClass("is-image-uploaded");
		$elms.cameraInput.val(""); // Clear the camera input
		$elms.galleryInput.val(""); // Clear the gallery input
		hasExistingPhoto = false; // Clear existing photo flag
		validateForm(); // Revalidate after photo removal
	});

	$elms.form.on("submit", function (e) {
		e.preventDefault();

		const firstName = $elms.firstName.val();
		const lastName = $elms.lastName.val();
		const photoFile = selectedPhotoFile; // Get the actual File object
		const username = $elms.generatedUsername.text();

		if (!firstName || !lastName) {
			alert("First name and last name are required");
			return;
		}

		// Create FormData object for file upload
		const formData = new FormData();
		formData.append("action", "edit_profile");
		formData.append("first_name", firstName);
		formData.append("last_name", lastName);
		formData.append("username", username);
		formData.append("nonce", window.CFG.nonce);
		formData.append("user_id", $elms.page.attr("data-user-id"));

		// Add photo if selected
		if (photoFile) {
			formData.append("photo", photoFile);
		}

		// Disable form during submission
		$elms.saveProfile.prop("disabled", true);
		$elms.saveProfile.addClass("is-loading");

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: formData,
			processData: false, // Don't process the data
			contentType: false, // Don't set content type
			success: function (response) {
				if (response.success) {
					// Handle success - maybe redirect or show success message
					if (response.data.user_id) {
						window.location.href = `${window.CFG.siteURL}/profile-created/${response.data.user_id}`;
					}
				} else {
					// Handle error from server
					alert(
						response.data?.message ||
							"Failed to setup profile. Please try again.",
					);
				}
			},
			error: function (xhr, status, error) {
				console.error(error);
				alert("Failed to update profile. Please try again.");
			},
			complete: function () {
				// Re-enable form after submission
				$elms.saveProfile.prop("disabled", false);
				$elms.saveProfile.removeClass("is-loading");
			},
		});
	});
};
